import setReduxAction from '../set'
import { setIdReduxUtil } from '../../utils/set-id'

/**
 * Sets the `value` at the given `payload.path`.
 * @param {Object} action
 *        {string} action.path
 *        {String[]} [action.paths]
 *        {string} action.value
 *        {String[]} [action.values]
 *        {Object} [action.options]
 */
export function setIdReduxAction (action) {
  return (dispatch, getState) => {
    const state = setIdReduxUtil({
      state: getState(), ...action.payload
    })
    dispatch(setReduxAction({
      type: action.type,
      payload: {
        value: state
      }
    }))
  }
}
